module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_133726-697505902.c7107f04.jpg";